export const getOnetimeDeviceImportQuery = () => `
    query onetimeDeviceImport {
        onetimeDeviceImport {
            id
            state
            result
        }
    }
`;

export const triggerOnetimeDeviceImportMutation = () => `
    mutation triggerOnetimeDeviceImport {
        triggerOnetimeDeviceImport
    }
`;
